import { createSlice, isFulfilled } from "@reduxjs/toolkit";

import { duplicateFilter } from "components/common/Filters/Filters.slice";
import { deleteMyList, deleteSCList } from "components/features/Corp/CorpUser.Slice";
import {
  copyActionAsync,
  createSectionAsync,
  deleteActionCardAsync,
  deleteSectionAsync,
  editSectionAsync,
  markPlanCompleteAsync,
  patchAddInviteeAsync,
  patchReorderSectionsAsync,
  patchUpdateOwnershipAsync,
  removeMemberBulkActionAsync,
  updateMyPlanCardDetailAsync,
  updatePlanAsync
} from "components/features/MyPlanDetails/MyPlanDetails.slice";
import { deleteMyPlansAsync } from "components/features/MyPlans/myplans.slice";
import { updateInncodeUploadList, uploadMyList } from "components/features/SME/sme.slice";
import { joiningToPlanAsync } from "components/features/planDetails/PlanDetail.slice";
import { markCompleteSuccessMessage, messages } from "utils/CommonConstants";
import { responseStatusTypes } from "utils/Types";

const initialState: any = {
  fetchMyPlans: {},
  addToMyPlans: {},
  copyAction: {},
  updateMyPlanCardDetail: {},
  createSection: {},
  editSection: {},
  deleteSection: {},
  deletePlan: {},
  reorderSections: {},
  deleteActionCard: {},
  deleteMultipleActionCards: {},
  updatePlan: {},
  addInvitee: {},
  removeInvitee: {},
  updateOwner: {},
  recommendationsFileUpload: {},
  assignPlan: {},
  apiFailure: {},
  smeUploadMyList: {},
  deleteList: {},
  markComplete: {},
  renameDynamicList: {},
  saveFilterList: {},
  duplicateFilter: {},
  updateEditPermission: {},
  createFilterByTypes: {},
  updateFeedback: {}
};

export const FormSlice = createSlice({
  name: "forms",
  initialState,
  reducers: {
    reset: () => initialState,
    clearFormState: (state, action) => {
      state[action.payload] = {};
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(copyActionAsync.fulfilled, (state) => {
        state.copyAction.status = responseStatusTypes.success;
      })
      .addCase(updateMyPlanCardDetailAsync.fulfilled, (state) => {
        state.updateMyPlanCardDetail.status = responseStatusTypes.success;
      })
      .addCase(createSectionAsync.fulfilled, (state) => {
        state.createSection.status = responseStatusTypes.success;
      })
      .addCase(editSectionAsync.fulfilled, (state) => {
        state.editSection.status = responseStatusTypes.success;
      })
      .addCase(patchUpdateOwnershipAsync.fulfilled, (state, action: any) => {
        state.updateOwner.memberAction = action.meta?.arg?.memberAction;
        state.updateOwner.status = responseStatusTypes.success;
      })
      .addCase(patchUpdateOwnershipAsync.rejected, (state, action: any) => {
        state.updateOwner.status = responseStatusTypes.error;
        state.updateOwner.details = action.payload.errors;
      })
      .addCase(deleteSectionAsync.fulfilled, (state) => {
        state.deleteSection.status = responseStatusTypes.success;
      })
      .addCase(deleteMyPlansAsync.fulfilled, (state) => {
        state.deletePlan.status = responseStatusTypes.success;
      })
      .addCase(patchReorderSectionsAsync.fulfilled, (state) => {
        state.reorderSections.status = responseStatusTypes.success;
      })
      .addCase(deleteActionCardAsync.fulfilled, (state, action: any) => {
        const idsArray = action.meta.arg.cardId;
        if (idsArray?.length > 1 && action.meta.arg.cardEditable) {
          state.deleteMultipleActionCards.status = responseStatusTypes.success;
        } else {
          state.deleteActionCard.status = responseStatusTypes.success;
        }
      })
      .addCase(updatePlanAsync.fulfilled, (state) => {
        state.updatePlan.status = responseStatusTypes.success;
      })
      .addCase(patchAddInviteeAsync.fulfilled, (state) => {
        state.addInvitee.status = responseStatusTypes.success;
      })
      .addCase(removeMemberBulkActionAsync.fulfilled, (state) => {
        state.removeInvitee.status = responseStatusTypes.success;
      })
      .addCase(uploadMyList.fulfilled, (state, action: any) => {
        if (!action?.payload?.invalidMappings?.length) {
          state.smeUploadMyList.status = responseStatusTypes.success;
          state.smeUploadMyList.details = messages.listUploadSuccess;
        }
      })
      .addCase(markPlanCompleteAsync.fulfilled, (state, action: any) => {
        if (action?.meta?.arg?.type === "bulk_assign") {
          state.markComplete.status = responseStatusTypes.success;
          state.markComplete.details = "Your edits have been saved.";
          return;
        } else if (action?.payload?.totalCards !== action?.payload?.cardsCompleted) {
          state.markComplete.status = responseStatusTypes.success;
          state.markComplete.details = markCompleteSuccessMessage[action?.meta?.arg?.type];
        }
      })
      .addCase(updateInncodeUploadList.fulfilled, (state, action: any) => {
        state.smeUploadMyList.status = responseStatusTypes.success;
        state.smeUploadMyList.details = messages.listUploadSuccess;
      })
      .addCase(duplicateFilter.fulfilled, (state) => {
        state.duplicateFilter.status = responseStatusTypes.success;
      })
      .addMatcher(isFulfilled(joiningToPlanAsync), (state) => {
        state.addToMyPlans.status = responseStatusTypes.success;
      })
      .addMatcher(isFulfilled(deleteMyList, deleteSCList), (state) => {
        state.deleteList.status = responseStatusTypes.success;
      });
  }
});

export const { clearFormState, reset } = FormSlice.actions;
export default FormSlice.reducer;
